/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Dialect_Label_Ebrana_Getjob_XmlInputs */

const cs_import_dialect_label_ebrana_getjob_xml = /** @type {(inputs: Import_Dialect_Label_Ebrana_Getjob_XmlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`eBRÁNA GetJob XML (migrace)`)
};

const en_import_dialect_label_ebrana_getjob_xml = /** @type {(inputs: Import_Dialect_Label_Ebrana_Getjob_XmlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`eBRÁNA GetJob XML (migration)`)
};

/**
* | output |
* | --- |
* | "eBRÁNA GetJob XML (migration)" |
*
* @param {Import_Dialect_Label_Ebrana_Getjob_XmlInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_dialect_label_ebrana_getjob_xml = /** @type {((inputs?: Import_Dialect_Label_Ebrana_Getjob_XmlInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Dialect_Label_Ebrana_Getjob_XmlInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_dialect_label_ebrana_getjob_xml(inputs)
	return cs_import_dialect_label_ebrana_getjob_xml(inputs)
});